import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CLASSES_ERROR, CREATE_CLASS_DIVISION, CREATING_CLASS_DIVISION, GETTING_CLASSES, GET_CLASSES, UPDATE_CLASS, UPDATE_CLASS_DIVISION, UPDATING_CLASS, UPDATING_CLASS_DIVISION } from "../types"

export const updateClass = (classId, classPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_CLASS,
            payload: true
        })
        const response = await axios.put(`${baseUrl}/classes/${classId}`, classPayload, { headers })
        
        dispatch({
            type: UPDATE_CLASS,
            payload: response.data.data
        })
        
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: CLASSES_ERROR,
            // payload: error.response.data
            error
        })
    }
}

export const clearUpdatedClass = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_CLASS,
        payload: null
    })
}

export const fetchClasses = () => async dispatch => {    
    try{
        const headers = authHeader()
        let requestUrl = 'classes'

        dispatch( {
            type: GETTING_CLASSES,
            payload: true
        })

        const response = await axios.get(`${baseUrl}/${requestUrl}`, { headers })

        dispatch( {
            type: GET_CLASSES,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: CLASSES_ERROR,
            error
        })
    }
}


export const createClassDivision = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_CLASS_DIVISION,
            payload: true
        })
        const response = await axios.post(`${baseUrl}/class-divisions`, payload, { headers })
        
        dispatch({
            type: CREATE_CLASS_DIVISION,
            payload: response.data
        })
        
    }
    catch(error){
        dispatch({
            type: CLASSES_ERROR,
            error
        })
    }
}

export const clearCreatedClassDivision = () => async (dispatch) => {    
    dispatch({
        type: CREATE_CLASS_DIVISION,
        payload: null
    })
}

export const updateClassDivision = (id, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_CLASS_DIVISION,
            payload: true
        })

        const response = await axios.patch(`${baseUrl}/class-divisions/${id}`, payload, { headers })
        
        dispatch({
            type: UPDATE_CLASS_DIVISION,
            payload: response.data
        })
        
    }
    catch(error){
        dispatch({
            type: CLASSES_ERROR,
            error
        })
    }
}

export const clearUpdatedClassDivision = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_CLASS_DIVISION,
        payload: null
    })
}
